import { useEffect, useState } from 'react';

/**
 * Debounces a fast-changing value (e.g. a controlled text input) so
 * dependents (URL sync, queries) only react once input has settled.
 * `delayMs` defaults to 300 — long enough to skip mid-word keystrokes,
 * short enough that the settle doesn't read as lag.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => { setDebounced(value); }, delayMs);
    return () => { clearTimeout(timer); };
  }, [value, delayMs]);

  return debounced;
}
